export interface FaqItem {
  question: string
  answer: string
}

export interface FaqCategory {
  id: string
  title: string
  items: FaqItem[]
}

export const faqCategories: FaqCategory[] = [
  {
    id: 'faq-shipping-returns',
    title: 'Shipping & Returns',
    items: [
      {
        question: 'Do you offer free shipping?',
        answer:
          'Yes. We offer complimentary USPS shipping on all orders over $150 USD within the United States, with free local delivery across New York.',
      },
      {
        question: 'How long does delivery take?',
        answer:
          'Orders are prepared within 1–2 business days. USPS delivery usually takes 2–5 business days nationwide, and 1–2 business days within New York.',
      },
      {
        question: 'What is your returns policy?',
        answer:
          'Unworn pieces in their original packaging can be returned within 14 days of delivery. Write to us on WhatsApp or through the contact form and we will arrange the return with you.',
      },
      {
        question: 'Can I exchange a piece for another size?',
        answer:
          'Of course. Chains, bracelets, and rings can be exchanged for a different length or size within 14 days, subject to availability.',
      },
    ],
  },
  {
    id: 'faq-products-care',
    title: 'Products & Care',
    items: [
      {
        question: 'Is your jewelry solid gold?',
        answer:
          'Every ELORA piece is solid 18K Gold or 18K Italian Gold. We never sell plated or gold-filled jewelry.',
      },
      {
        question: 'How should I care for my pieces?',
        answer:
          'Store each piece separately in its pouch, keep it away from perfume and chlorine, and polish it gently with a soft dry cloth after wearing.',
      },
      {
        question: 'Do you make custom orders?',
        answer:
          'Yes. Send us a message with the length, weight, or design you have in mind and we will quote a custom piece with our goldsmiths.',
      },
    ],
  },
  {
    id: 'faq-orders-payment',
    title: 'Orders & Payment',
    items: [
      {
        question: 'How do I place an order?',
        answer:
          'Message us on WhatsApp at +1 (631) 388-9620 or write through the contact form below, and we will confirm availability and payment with you personally.',
      },
      {
        question: 'How do I get 10% off my first order?',
        answer:
          'Contact us by email at eloragoldny@gmail.com before your first purchase and we will apply a 10% discount to your order.',
      },
    ],
  },
]
